import { jsx as _jsx } from "react/jsx-runtime";
import { AppIcon, Theme } from '@streem/ui-react';
import { useEffect, useCallback } from 'react';
import { audio } from '../media/sounds';
export const useNotifyOfAudioInputDeviceChange = ({ addNotification, removeNotification, }) => {
    const handleAudioInputDeviceChanged = useCallback((audioInputDevice) => {
        const notificationId = 'auto-audio-input-changed';
        addNotification({
            id: notificationId,
            message: `Microphone changed to ${audioInputDevice.label}`,
            icon: _jsx(AppIcon, { color: Theme.colors.green50, name: "DoneIcon" }),
            useCloseButton: true,
            onActionClick: () => removeNotification(notificationId),
            timeout: 100000,
        });
    }, [addNotification, removeNotification]);
    useEffect(() => {
        audio.subscribeToAudioInputDeviceChanged(handleAudioInputDeviceChanged);
        return () => {
            audio.unsubscribeToAudioInputDeviceChanged(handleAudioInputDeviceChanged);
        };
    }, [handleAudioInputDeviceChanged]);
};
//# sourceMappingURL=use_notify_of_audio_input_change.js.map